<script lang="ts">
  interface Props {
    size?: number;
    [key: string]: any;
  }

  let { size = 16, ...rest }: Props = $props();
</script>

<svg
  width={size}
  height={size}
  viewBox="0 0 16 16"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  {...rest}
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M4.5 15H14V1H4.25C3.00736 1 2 2.00736 2 3.25V12.25H2.0127C2.00453 12.3322 2 12.4156 2 12.5C2 13.7943 2.98361 14.8592 4.24414 14.9873L4.5 15ZM3.5 12.5C3.5 11.9477 3.94772 11.5 4.5 11.5H12.5V13.5H4.5C3.94772 13.5 3.5 13.0523 3.5 12.5ZM3.5 3.25C3.5 2.83579 3.83579 2.5 4.25 2.5H5V6.5L6.5 5.5L8 6.5V2.5H12.5V10H4.5L4.24414 10.0127C3.9817 10.0394 3.73206 10.1085 3.5 10.21V3.25Z"
    fill="currentColor"
  />
</svg>
